import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { createEntitySliceSelectors, createListSliceSelectors } from '@aston/foundation';

import { IFederationDetailState } from './state';
import { FeatureName } from './feature';


export const selectState: MemoizedSelector<object, IFederationDetailState> = createFeatureSelector<IFederationDetailState>(FeatureName);

export const getCurrentFederationId = (state: IFederationDetailState): number => state.currentFederationId;
export const selectCurrentFederationId = createSelector(selectState, state => getCurrentFederationId(state));

export const {
	selectEntity: selectFederation,
	selectIsLoading: selectFederationIsLoading,
	selectError: selectFederationError
} = createEntitySliceSelectors(createSelector(selectState, state => state.federationForm));

export const {
	selectSlice: selectUsersListSlice,
	selectList: selectUsersList,
	selectFilters: selectUsersFilters,
	selectError: selectUsersError,
	selectIsLoading: selectUsersIsLoading,
	selectPaging: selectUsersListPaging,
} = createListSliceSelectors(createSelector(selectState, (state) => state.usersList));

export const {
	selectEntity: selectUserStatus,
	selectIsLoading: selectUserStatusIsLoading,
	selectError: selectUserStatusError
} = createEntitySliceSelectors(createSelector(selectState, state => state.transientUserStatus));

export const getFederationFormIsEditing = (state: IFederationDetailState): boolean => state.federationFormIsEditing;
export const selectFederationFormIsEditing = createSelector(selectState, state => getFederationFormIsEditing(state));
